import { render } from "./physiotherapy_session.vue?vue&type=template&id=114ec326&scoped=true"
import script from "./physiotherapy_session.vue?vue&type=script&lang=js"
export * from "./physiotherapy_session.vue?vue&type=script&lang=js"

import "./physiotherapy_session.vue?vue&type=style&index=0&id=114ec326&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-114ec326"]])

export default __exports__